import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import ExpandToggleButton from '@/_core/shared/ui/ExpandToggleButton/ExpandToggleButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
    maxHeight: { default: 150 },
    maxDesktopHeight: { default: 230 }
  },
  setup(__props: any) {

const props = __props as { maxHeight: number, maxDesktopHeight: number };



const isExpanded = ref(false);

return { __sfc: true,props, isExpanded, ExpandToggleButton }
}

})